<mat-toolbar color="primary" class="app-toolbar">
  @if (showAuthenticatedShell) {
    <button
      #navigationToggle
      mat-button
      type="button"
      class="nav-toggle"
      (click)="toggleNavigation()"
      [attr.aria-expanded]="navigationOpen"
      aria-controls="app-navigation-panel"
      [attr.aria-label]="(navigationOpen ? 'navigation.close' : 'navigation.open') | t">
      <span class="menu-icon" aria-hidden="true">
        <span></span>
        <span></span>
        <span></span>
      </span>
    </button>
  }

  <a
    routerLink="/"
    [queryParams]="domainNavigationQueryParams"
    class="brand"
    [class.home-return]="showHomeReturn"
    [attr.aria-label]="(showHomeReturn ? 'app.backHomeAria' : 'app.homeAria') | t">
    <img class="brand-mark" src="brand/pulse-logo.svg" alt="" width="36" height="36">
    @if (showHomeReturn) {
      <span class="brand-return-arrow" aria-hidden="true">←</span>
    }
    <span class="brand-copy">LifeOps</span>
    <span class="brand-version">{{ appVersion }}</span>
  </a>

  @if (showAuthenticatedShell && activeTimerCount > 0) {
    <a
      routerLink="/activities"
      fragment="active-timers"
          [queryParams]="{ returnTo: currentUrl }"
      class="global-timer-indicator"
      [attr.aria-label]="(activeTimerCount === 1 ? 'navigation.activeTimer.one' : 'navigation.activeTimer.many') | t:{ count: activeTimerCount }">
      <span aria-hidden="true">⏱</span>
      <span>
        {{ (activeTimerCount === 1 ? 'navigation.activeTimer.one' : 'navigation.activeTimer.many') | t:{ count: activeTimerCount } }}
      </span>
    </a>
  }

  @if (showAuthenticatedShell && domains.length) {
    <div class="global-domain-filter">
      <select
        [attr.aria-label]="'domains.homeFilter' | t"
        [title]="'domains.homeFilter' | t"
        [ngModel]="selectedDomainId"
        (ngModelChange)="changeGlobalDomain($event)"
        [style.background]="activeDomain ? domainOptionColor(activeDomain) : null">
        <option [ngValue]="null">{{ compactToolbar ? 'Dominios' : ('domains.allDomains' | t) }}</option>
        @for (domain of domains; track domain.id) {
          <option [ngValue]="domain.id" [style.background]="domainOptionColor(domain)">{{ domain.name }}</option>
        }
      </select>
    </div>
  }

  <span class="spacer"></span>

  @if (sb.isLoggedIn) {
    <div class="profile-actions">
      <a
        routerLink="/settings"
    [queryParams]="{ returnTo: currentUrl }"
        mat-button
        class="session-action settings-action"
        [attr.aria-label]="'app.settings' | t"
        [title]="'app.settings' | t">
        <span class="settings-icon" aria-hidden="true">⚙</span>
      </a>
    </div>

    <button
      mat-button
      type="button"
      class="session-action sign-out-action"
      (click)="logout()"
      [attr.aria-label]="'app.signOut' | t"
      [title]="'app.signOut' | t">
      <svg class="sign-out-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M9 4H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4"/>
        <path d="m15 7 5 5-5 5M20 12H9"/>
      </svg>
    </button>
  } @else {
    <a routerLink="/login" mat-button class="session-action">{{ 'app.signIn' | t }}</a>
  }
</mat-toolbar>

@if (showAuthenticatedShell && navigationOpen) {
  <button
    type="button"
    class="navigation-backdrop"
    (click)="closeNavigation(true)"
    [attr.aria-label]="'navigation.close' | t">
  </button>

  <aside id="app-navigation-panel" class="navigation-drawer">
    <div class="navigation-heading">
      <strong>{{ 'navigation.main' | t }}</strong>
      <button
        type="button"
        class="drawer-close"
        (click)="closeNavigation(true)"
        [attr.aria-label]="'navigation.close' | t">
        ×
      </button>
    </div>

    <nav class="navigation-list" [attr.aria-label]="'navigation.main' | t">
      @for (item of navigationItems; track item.route) {
        @if (item.children?.length) {
          <div class="navigation-group">
            <button
              type="button"
              class="navigation-link navigation-group-toggle"
              [class.active]="isNavigationRouteActive(item.route)"
              [attr.aria-expanded]="isNavigationGroupExpanded(item.route)"
              (click)="toggleNavigationGroup(item.route)">
              <span class="navigation-icon" aria-hidden="true">
                @switch (item.icon) {
                  @case ('tasks') {
                    <svg viewBox="0 0 24 24"><path d="m4 6 1.5 1.5L8 5M10 6h10M4 12l1.5 1.5L8 11M10 12h10M4 18l1.5 1.5L8 17M10 18h10"/></svg>
                  }
                  @case ('goals') {
                    <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="4"/><path d="m15 9 5-5M16 4h4v4"/></svg>
                  }
                }
              </span>
              <span>{{ item.labelKey | t }}</span>
              <span class="navigation-chevron" aria-hidden="true">
                {{ isNavigationGroupExpanded(item.route) ? '⌃' : '⌄' }}
              </span>
            </button>

            @if (isNavigationGroupExpanded(item.route)) {
              <div class="navigation-sublist">
                <a [routerLink]="item.route" [queryParams]="domainNavigationQueryParams"
                  class="navigation-sublink navigation-sublink-overview" (click)="closeNavigation()">
                  {{ 'navigation.overview' | t }}
                </a>
                @for (child of item.children; track child.labelKey) {
                  <a
                    [routerLink]="item.route"
                    [queryParams]="childNavigationQueryParams(child)"
                    routerLinkActive="active"
                    class="navigation-sublink"
                    (click)="closeNavigation()">
                    {{ child.labelKey | t }}
                  </a>
                }
              </div>
            }
          </div>
        } @else {
          <a
            #firstNavigationLink
            [routerLink]="item.route"
            [queryParams]="domainNavigationQueryParams"
            routerLinkActive="active"
            class="navigation-link"
            (click)="closeNavigation()">
            <span class="navigation-icon" aria-hidden="true">
              @switch (item.icon) {
                @case ('today') {
                  <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M12 2v3M12 19v3M2 12h3M19 12h3M5 5l2 2M17 17l2 2M19 5l-2 2M7 17l-2 2"/></svg>
                }
                @case ('calendar') {
                  <svg viewBox="0 0 24 24"><path d="M7 3v3M17 3v3M4 9h16M5 5h14a1 1 0 0 1 1 1v14H4V6a1 1 0 0 1 1-1Z"/><path d="M8 13h3v3H8z"/></svg>
                }
                @case ('notes') {
                  <svg viewBox="0 0 24 24"><path d="M5 3h11l3 3v15H5z"/><path d="M16 3v4h4M8 11h8M8 15h8"/></svg>
                }
                @case ('activities') {
                  <svg viewBox="0 0 24 24"><circle cx="12" cy="13" r="7"/><path d="M12 13V9M9 2h6M15.5 5.5 17 4"/></svg>
                }
                @case ('sport') {
                  <svg viewBox="0 0 24 24"><path d="M7 5v14M17 5v14M4 8h3M17 8h3M4 16h3M17 16h3M7 12h10"/></svg>
                }
                @case ('lists') {
                  <svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M8 9h8M8 13h8M8 17h5"/></svg>
                }
                @case ('measurements') {
                  <svg viewBox="0 0 24 24"><path d="M3 17h4l3-7 4 10 3-7h4"/><path d="M3 4h18"/></svg>
                }
                @case ('meals') {
                  <svg viewBox="0 0 24 24"><path d="M5 3v9M8 3v9M5 9h3M6.5 12v9M15 3v18M15 3c7 4 7 10 0 11"/></svg>
                }
                @case ('culture') {
                  <svg viewBox="0 0 24 24"><path d="M3 5h8v14H3zM13 5h8v14h-8zM6 9h3M16 9h3M6 13h3M16 13h3"/></svg>
                }
                @case ('domains') {
                  <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><circle cx="12" cy="5" r="2"/><circle cx="5" cy="18" r="2"/><circle cx="19" cy="18" r="2"/><path d="M12 7v2M10 14l-4 3M14 14l4 3"/></svg>
                }
              }
            </span>
            <span>{{ item.labelKey | t }}</span>
          </a>
        }
      }
    </nav>
  </aside>
}

<app-page-container>
  <router-outlet></router-outlet>
</app-page-container>
